export const attrValue: { [id: string]: string } = {
  "1": "LETTER",
  "2": "SPACE",
  "3": "POSSIBLE_VACAT",
  "4": "VACAT",
  "5": "DAMAGE",
  "6": "BLANK LINE",
  "7": "PARAGRAPH_MARKER",
  "8": "LACUNA",
  "9": "BREAK",
  "10": "LINE_START",
  "11": "LINE_END",
  "12": "COLUMN_START",
  "13": "COLUMN_END",
  "14": "SCROLL_START",
  "15": "SCROLL_END",
  "16": "",
  "17": "MIGHT_BE_WIDER",
  "18": "INCOMPLETE_BUT_CLEAR",
  "19": "INCOMPLETE_AND_NOT_CLEAR",
  "20": "IS_RECONSTRUCTED",
  "21": "CONJECTURE",
  "22": "SHOULD_BE_ADDED",
  "23": "SHOULD_BE_DELETED",
  "24": "OVERWRITTEN",
  "25": "HORIZONTAL_LINE",
  "26": "DIAGONAL_LEFT_LINE",
  "27": "DIAGONAL_RIGHT_LINE",
  "28": "DOT_BELOW",
  "29": "DOT_ABOVE",
  "30": "LINE_BELOW",
  "31": "LINE_ABOVE",
  "32": "BOXED",
  "33": "ERASED",
  "34": "ABOVE_LINE",
  "35": "BELOW_LINE",
  "36": "LEFT_MARGIN",
  "37": "RIGHT_MARGIN",
  "38": "MARGIN",
  "39": "UPPER_MARGIN",
  "40": "LOWER_MARGIN"
};
